import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, MailOutlined, EnvironmentOutlined, IdcardOutlined } from "@ant-design/icons";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="profile-page">
      <div className="profile-shell">
        <button type="button" className="profile-back-button" onClick={goBack}>
          <ArrowLeftOutlined />
          <span>Go back</span>
        </button>

        <div className="profile-hero-card">
          <div className="profile-hero-sidebar">
            <img
              src={state.src}
              alt={state.name || "Profile"}
              className="profile-hero-image"
            />
          </div>

          <div className="profile-hero-content">
            <div className="profile-hero-heading">
              <h1 className="profile-name">{state.name || "Team Member"}</h1>
              <p className="profile-role">{state.title || "Leadership Team"}</p>
            </div>

            <div className="profile-details-grid">
              <div className="profile-detail-card profile-detail-card-full">
                <div className="profile-detail-summary">
                  <div className="profile-detail-row">
                    <div className="profile-detail-icon"><MailOutlined /></div>
                    <div className="profile-detail-copy">
                      <span className="profile-detail-label">Email</span>
                      <span className="profile-detail-value">{state.email || "Not provided"}</span>
                    </div>
                  </div>
                  <div className="profile-detail-row">
                    <div className="profile-detail-icon"><EnvironmentOutlined /></div>
                    <div className="profile-detail-copy">
                      <span className="profile-detail-label">Address</span>
                      <span className="profile-detail-value">{state.address || "Not provided"}</span>
                    </div>
                  </div>
                </div>

                <div className="profile-bio-block">
                  <div className="profile-detail-row profile-detail-row-bio">
                    <div className="profile-detail-icon"><IdcardOutlined /></div>
                    <div className="profile-detail-copy">
                      <span className="profile-detail-label">Bio</span>
                      <span className="profile-detail-value profile-detail-value-bio">
                        {state.bio || "Biography not available."}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
